import { EventStatus } from "../event-page-models/event-status";

export const eventPageUtils = {
  eventStatusToText: (status: EventStatus): string => {
    switch (status) {
      case EventStatus.ByDate:
        return "לפי תאריך";
      case EventStatus.Closed:
        return "סגור";
      case EventStatus.Open:
        return "פתוח";
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/admin/events-screen/utils/event-page-utils.ts